// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BrandBanner_wrapper__kqyO8","container":"BrandBanner_container__zw2V1"};